// extracted by mini-css-extract-plugin
export default {"upgrades":"N1mfT","upgradePrice":"gUHib"};